import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, FileText } from 'lucide-react';
import { Logo } from './Logo';
import { Button } from './BrandingSystem';
interface CTAScreenProps {
  onShowDisclaimer?: () => void;
}
export function CTAScreen({
  onShowDisclaimer
}: CTAScreenProps) {
  return <motion.div initial={{
    opacity: 0,
    scale: 0.95
  }} animate={{
    opacity: 1,
    scale: 1
  }} className="w-full max-w-2xl mx-auto bg-white rounded-xl overflow-hidden shadow-lg" data-id="element-1">
      <div className="bg-brand-primary p-1" data-id="element-2"></div>
      <div className="p-6 md:p-8" data-id="element-3">
        <h2 className="text-2xl md:text-3xl font-bold text-brand-primary mb-8" data-id="element-4">
          Flexible. Recommended. Accessible.
        </h2>

        <div className="flex items-center gap-4" data-id="element-5">
          <Button variant="primary" onClick={() => window.open('https://gskpro.com/en-caricam/products/augmentin/', '_blank')} data-id="element-6">
            Explore Augmentin <ArrowRight className="w-4 h-4 ml-2 inline" data-id="element-7" />
          </Button>

          <button onClick={onShowDisclaimer} className="inline-flex items-center gap-1.5 px-4 py-2.5 text-xs font-semibold text-gray-500 bg-gray-100 rounded-lg border border-gray-200 hover:bg-gray-200 hover:text-gray-700 transition-colors" data-id="element-8">
            <FileText className="w-3.5 h-3.5" data-id="element-9" />
            Legal Disclaimer
          </button>
        </div>
      </div>
    </motion.div>;
}